"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyContainer = void 0;
const react_1 = __importStar(require("react"));
const server_1 = require("../../../../server");
const SurveyLayout_1 = require("./SurveyLayout");
const react_redux_1 = require("react-redux");
const account_1 = require("../../account");
const SurveyResultLayout_1 = require("./SurveyResultLayout");
const constant_1 = require("./constant");
const default_survey = [
    {
        id: 'id-0',
        title: '',
        type: constant_1.SURVEY_TYPE.OBJECTIVE,
        data: [],
    },
];
const getSurveyData = (testItem, questionList, submittedAnswers) => {
    const combinedArray = questionList.map((i) => {
        if (!testItem.survey_questions)
            return;
        const question = testItem.survey_questions[i.id];
        const questionAnswers = submittedAnswers?.filter(answer => answer.question_id === i.id);
        return {
            id: i.id,
            type: i.type,
            title: question ? question.title : null,
            data: i.type === 'choice' || i.type === 'checkbox'
                ? question?.options.map((option, optionIndex) => ({
                    id: `${i.id}-${option}-${optionIndex}`,
                    title: option,
                    checked: questionAnswers.some(answer => answer.value === option),
                })) || []
                : questionAnswers.length > 0
                    ? questionAnswers[0].value
                    : '',
        };
    });
    return combinedArray.filter(i => i);
};
exports.SurveyContainer = react_1.default.memo(({ member_id, test_id, item, isPreview, submitted, questionId, handlerUpdateSurveyData, isRegist, }) => {
    const isTeacher = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsTeacher)(state));
    const [surveyData, setSurveyData] = react_1.default.useState([]);
    const [questionList, setQuestionList] = react_1.default.useState([]);
    const [answerList, setAnswerList] = react_1.default.useState([]);
    const { data: questionData, refetch: refetchQuestionData } = (0, server_1.useQuestionList)({
        test_id,
        orderby: ["IF(subject_item='공통',0,1)", 'subject_item', 'number'],
    });
    const { data: submittedAnswers, refetch: refetchAnswerData } = (0, server_1.useAnswerList)({
        test_id,
        from: member_id || '',
        order: 'value',
    });
    const { data: frequencyData, refetch: refetchFrequencyData } = (0, server_1.useSurveyFrequency)(test_id);
    (0, react_1.useEffect)(() => {
        if (test_id) {
            refetchQuestionData();
            member_id !== '' && refetchAnswerData();
            refetchFrequencyData();
        }
    }, [isPreview, isTeacher, test_id, member_id, submitted]);
    (0, react_1.useEffect)(() => {
        if (test_id)
            return;
        if (questionId === 'survey' || questionId === 'survey-poll') {
            setSurveyData(default_survey);
        }
    }, [questionId, test_id]);
    (0, react_1.useEffect)(() => {
        if (questionData) {
            setQuestionList(questionData.items);
        }
        else {
            setQuestionList([]);
        }
    }, [questionData]);
    (0, react_1.useEffect)(() => {
        if (member_id === '') {
            setAnswerList([]);
            return;
        }
        if (submittedAnswers) {
            setAnswerList(submittedAnswers.items);
        }
        else {
            setAnswerList([]);
        }
    }, [member_id, submittedAnswers]);
    (0, react_1.useEffect)(() => {
        if (test_id && questionList && answerList) {
            const survey = getSurveyData(item, questionList, answerList);
            setSurveyData(survey && survey.length === 0 ? default_survey : survey);
        }
    }, [test_id, questionList, answerList]);
    if (member_id && item.status !== 'created' && !submitted) {
        return (react_1.default.createElement("div", { className: "submit-false" },
            react_1.default.createElement("p", null, "\uBBF8\uC81C\uCD9C \uC0AC\uC6A9\uC790 \uC785\uB2C8\uB2E4.")));
    }
    if (isRegist) {
        return (react_1.default.createElement("div", { className: "flex column survey_wrapper" },
            react_1.default.createElement(SurveyLayout_1.SurveyLayout, { surveyData: surveyData, isRegist: true, setSurveyData: handlerUpdateSurveyData })));
    }
    else {
        if (isPreview) {
            return (react_1.default.createElement("div", { className: "survey-submit-view" },
                react_1.default.createElement(SurveyLayout_1.SurveyLayout, { surveyData: surveyData, isSubmit: false, isRegist: false })));
        }
        else {
            if (member_id !== '') {
                return (react_1.default.createElement("div", { className: "survey-submit-view" },
                    react_1.default.createElement(SurveyLayout_1.SurveyLayout, { surveyData: surveyData, isSubmit: member_id === '' ? true : submitted, isRegist: false })));
            }
            return (react_1.default.createElement("div", { className: "survey-submit-view" },
                react_1.default.createElement(SurveyResultLayout_1.SurveyResultLayout, { surveyData: surveyData, isSubmit: true, isRegist: false, frequencies: frequencyData || {} })));
        }
    }
});
